import { render, staticRenderFns } from "./apiDocking.vue?vue&type=template&id=fc92ad50"
import script from "./apiDocking.vue?vue&type=script&lang=js"
export * from "./apiDocking.vue?vue&type=script&lang=js"
import style0 from "./apiDocking.vue?vue&type=style&index=0&id=fc92ad50&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports